// extracted by mini-css-extract-plugin
export default {"container":"projectList_container__0xQxr","crossIcon":"projectList_crossIcon__MdzBD"};